var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editPlaylist }
            },
            [_vm._v("Edit Trending Playlist")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.playlist
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.playlist.playlistId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Title")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.playlist.playlistTitle))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.playlist.playlistDescription))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Videos")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.playlist.csvVideoCodes))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Video Count")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.playlist.videoCount))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.playlist.active == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Trending Playlist Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebbe93c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebbe93c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/TrendingPlaylists/TrendingPlaylistDetails.vue
// module id = boMP
// module chunks = 0